var Api = (function() {
    var _this, STATUS, CONFIG;

    if (!Promise.prototype.finally) {
        Promise.prototype.finally = function (callback) {
            return this.then(
                value => Promise.resolve(callback()).then(() => value),
                reason => Promise.resolve(callback()).then(() => { throw reason; })
            );
        };
    }

    CONFIG = {
        TOKEN_KEY: 'Api.Token',
        API_URL: ScoreTrekBattle.ENV.API,
        TIMEZONE: (window.Intl && window.Intl.DateTimeFormat) ? window.Intl.DateTimeFormat().resolvedOptions().timeZone : 'Europe/Berlin',
        LANGUAGE: ScoreTrekBattle.ENV.LANGUAGE
    };

    STATUS = {
        initialized: false,
        id: 0,
        resolver: {},
        online: false,
        tokenRefreshPromise: null
    };

    function getCurrentToken() {
        return chmStorage.get(CONFIG.TOKEN_KEY, true);
    }

    function handlePostMessage(event) {
        var data;

        try {
            data = JSON.parse(event.data);

            if (data && data.type && data.data && (data.event === 'app.to.battle')) {
                if (data.type === 'response') {
                    if (STATUS.resolver.hasOwnProperty(data.data.eventId)) {
                        STATUS.resolver[data.data.eventId].call(null, data.data.eventData);
                        delete STATUS.resolver[data.data.eventId];
                    } else {
                        console.warn('Ignoring invalid event response.', data.data);
                    }
                } else if (data.type === 'event') {
                    ScoreTrekBattle.Event.trigger(`app.to.battle.${data.data.eventType}`, [data.data.eventData]);
                } else {
                    console.warn('Ignoring invalid post message data.', data);
                }
            } else {
                console.warn('Ignoring unidentified post message.', event);
            }
        } catch(e) {
            console.error(e);
        }
    }

    function postRequest(url, data, headers) {
        return new Promise(function(resolve, reject) {
            var adminClubId;
            if (!data) {
                data = {};
            }
            if (!headers) {
                headers = {};
            }
            if (!headers.hasOwnProperty('Authorization')) {
                headers['Authorization'] = `Token ${getCurrentToken()}`;
            }
            if (!headers.hasOwnProperty('Content-Type')) {
                headers['Content-Type'] = 'application/json; charset=utf-8';
            }
            headers['X-Client-Timezone'] = CONFIG.TIMEZONE;
            headers['X-Client-Language'] = CONFIG.LANGUAGE;

            if (ScoreTrekBattle.Session.isAdminMode()) {
                adminClubId = ScoreTrekBattle.Session.getAdminClubId();
                if (adminClubId) {
                    data.adminClubId = adminClubId;
                }
            }

            try {
                fetch(
                    url,
                    {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'omit',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        headers: headers,
                        body: JSON.stringify(data)
                    }
                ).then(function(response) {
                    response.text().then(text => {
                        var textParts, json;

                        text = String(text).trim();

                        if (text.charAt(0) !== '{') {
                            textParts = text.split('{');
                            debug({debug: [textParts.shift()]}, url, data);
                            text = `{${textParts.join('{')}`;
                        }

                        if (text.charAt(text.length-1) !== '}') {
                            textParts = text.split('}');
                            debug({debug: [textParts.pop()]}, url, data);
                            text = `${textParts.join('}')}}`;

                            if (text === '}') {
                                text = '{}';
                            }
                        }

                        try {
                            json = JSON.parse(text);
                        } catch(error) {
                            console.warn('Invalid JSON.', text);
                            reject({
                                error: true,
                                message: error.message,
                                thrownError: error
                            });
                            return;
                        }

                        if (response.status === 200) {
                            resolve(json);
                        } else {
                            reject(json);
                        }
                    }).catch(error => {
                        reject({
                            error: true,
                            message: error.message,
                            thrownError: error
                        });
                    });
                }).catch(error => {
                    reject({
                        error: true,
                        message: 'FAILED_TO_FETCH',
                        thrownError: error
                    });
                });
            } catch(error) {
                reject({
                    error: true,
                    message: 'FAILED_TO_FETCH',
                    thrownError: error
                });
            }
        });
    }

    function toggleOnline(isOnline) {
        var wasOnline;
        wasOnline = STATUS.online;
        STATUS.online = isOnline;
        if (wasOnline != STATUS.online) {
            ScoreTrekBattle.$body.attr('data-network-status', STATUS.online ? 'online' : 'offline');
        }
    }

    function debug(result, url, data) {
        if (!result) {
            return;
        }
        if (result.hasOwnProperty('debug') && (result.debug.length > 0)) {
            console.group(`[API] Debug Messages ${url}`);
                console.groupCollapsed('Payload');
                    console.log(data);
                console.groupEnd();
                console.group('Messages');
                    result.debug.forEach(function(message) {
                        console.log(message);
                    });
                console.groupEnd();
            console.groupEnd();
        }
        if (result.hasOwnProperty('debugSQL') && (result.debugSQL.length > 0)) {
            console.groupCollapsed(`[API] Debug SQL ${url}`);
                console.groupCollapsed('Payload');
	                console.log(data);
                console.groupEnd();
                console.group(`Queries (${result.debugSQL.length})`);
                    result.debugSQL.forEach(function(message) {
                        var query;
                        query = Array.isArray(message.query) ? message.query.join('\n') : message.query;
                        if (message.trace) {
                            console.groupCollapsed(query);
                            console.log(message.trace);
                            console.groupEnd();
                        } else {
                            console.log(query);
                        }
                        if (message.error) {
                            console.log(message.error);
                        }
                    });
                console.groupEnd();
                console.groupCollapsed('Grouped Queries');
                    let queryGroups = {}, queryGroupsList = [];
                    result.debugSQL.forEach(function(message) {
                        let query, queryParts, queryMain, queryWhere;

                        query = Array.isArray(message.query) ? message.query.join('\n') : message.query;
                        queryParts = String(query).split(' WHERE ');
                        queryMain = queryParts.shift();
                        queryWhere = queryParts.join(' WHERE ');

                        queryGroups[queryMain] = queryGroups[queryMain] || [];

                        queryGroups[queryMain].push(query);
                    });

                    Object.keys(queryGroups).forEach(queryMain => {
                        queryGroupsList.push({
                            label: queryMain,
                            count: queryGroups[queryMain].length,
                            queries: queryGroups[queryMain]
                        });
                    });

                    queryGroupsList.sort((queryGroupA, queryGroupB) => {
                        return (queryGroupA.count > queryGroupB.count) ? -1 : 1;
                    });

                    queryGroupsList.forEach(queryGroupItem => {
                        console.groupCollapsed(`${queryGroupItem.count}x -> ${queryGroupItem.label}`);
							queryGroupItem.queries.sort((queryA, queryB) => {
								return (queryA > queryB) ? 1 : -1;
							});
							queryGroupItem.queries.forEach(query => {
								console.log(query);
							});
                        console.groupEnd();
                    });
                console.groupEnd();

                if (result.hasOwnProperty('debugSQLduplicates') && (result.debugSQLduplicates.length > 0)) {
                    console.groupCollapsed(`Duplicate Queries (${result.debugSQLduplicates.length})`);
						result.debugSQLduplicates.forEach(function(message) {
							console.log(message);
						});
                    console.groupEnd();
                }

            console.groupEnd();
        }
        if (result.hasOwnProperty('notes') && (result.notes.length > 0)) {
            console.groupCollapsed('[API] Notes');
            result.notes.forEach(function(message) {
                console.log(message);
            });
            console.groupEnd();
        }
    }

    _this = {
        toApp: function(eventType, eventData) {
            return new Promise(function(resolve) {
                var timeoutWatcher;

                if (!ScoreTrekBattle.Session.isAppMode()) {
                    resolve(false);
                    return;
                }

                STATUS.id++;
                eventId = `event_${STATUS.id}`;

                STATUS.resolver[eventId] = function(result) {
                    clearTimeout(timeoutWatcher);
                    resolve(result);
                };

                window.parent.postMessage(JSON.stringify({
                    type: 'event',
                    event: 'battle.to.app',
                    data: {
                        eventType: eventType,
                        eventId: eventId,
                        eventData: eventData
                    }
                }), '*');

                timeoutWatcher = setTimeout(() => {
                    STATUS.resolver[eventId] = () => {};
                    resolve(false);
                }, 10000);
            });
        },
        init: function() {
            let updateTimer;

            if (STATUS.initialized) {
                return;
            }

            chmStorage.onUpdate(CONFIG.TOKEN_KEY, function(newValue, oldValue) {
                clearTimeout(updateTimer);
                updateTimer = setTimeout(() => {
                    ScoreTrekBattle.Event.trigger('api.token.update');
                }, 3000);
            });
        },

        setToken: function(token) {
            chmStorage.set(CONFIG.TOKEN_KEY, token);
        },

        getToken: function() {
            return getCurrentToken();
        },

        refreshTokenFromApp: function() {
            // Idempotent: concurrent callers share the same in-flight promise,
            // so we only ever have one authenticate roundtrip with the app.
            if (STATUS.tokenRefreshPromise) {
                return STATUS.tokenRefreshPromise;
            }

            if (!ScoreTrekBattle.Session.isAppMode()) {
                return Promise.resolve(false);
            }

            ScoreTrekBattle.View.loadingBackground('Api.refreshTokenFromApp', true);

            STATUS.tokenRefreshPromise = _this.toApp('authenticate').then(result => {
                if (!result || !result.token || result.token.error) {
                    return false;
                }
                _this.setToken(result.token);
                return true;
            });

            STATUS.tokenRefreshPromise.catch(() => {}).then(() => {
                STATUS.tokenRefreshPromise = null;
                ScoreTrekBattle.View.loadingBackground('Api.refreshTokenFromApp', false);
            });

            return STATUS.tokenRefreshPromise;
        },

		request: function(target, data) {
            target = String(target);
            return new Promise(function(resolve, reject) {
                var url;
                url = `${CONFIG.API_URL}${target.substr((target.substr(0,1) == '/') ? 1 : 0)}`;
                postRequest(url, data).then(
                    function(result) {
                        toggleOnline(true);
                        debug(result, url, data);
                        resolve(result.data);
                    }
                ).catch(
                    function(error) {
                        toggleOnline(false);
                        debug(error, url, data);

                        // api.INVALID_TOKEN means the battle token expired.
                        // In app mode the user is always authenticated against
                        // the app, so kick off a background refresh — the next
                        // user action will then use a fresh token.
                        // (refreshTokenFromApp is a no-op outside app mode.)
                        if (error && (error.message === 'api.INVALID_TOKEN')) {
                            _this.refreshTokenFromApp();
                        }

                        reject(error);
                    }
                );
            });
		},

        isOnline: function() {
            return STATUS.online;
        }
    };

    window.addEventListener('load', _this.init);

    window.addEventListener('message', handlePostMessage);

    return _this;
})();